class ChecklistShareComponent extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      jsonData: '#checklist-json-data',
      listGroup: '#checklist-group-html',
      checkListItem: '#checklist-list-item',
      cartDataJson: 'currentCartData',
      sideBar: '[customer-sidebar]',
      header: '.header[is="sticky-header"]',
      contentWrapper: '[content-wrapper]',
      categoriesTabs: '#categories-tabs-html'
    }
    this.purchasedProducts = {};
    this.initJson();
    this.init();

  }

  initJson() {
    const rawData = this.querySelector(this.selectors.jsonData)?.textContent;
    console.log('🔍 DEBUG: Raw JSON data from page:', rawData ? 'Found' : 'Not found');
    
    try {
      this.jsonData = rawData ? JSON.parse(rawData) : null;
      console.log('🔍 DEBUG: Parsed JSON data:', this.jsonData);
      
      if (this.jsonData) { 
        localStorage.setItem('customer_data_json', JSON.stringify(this.jsonData)); 
        console.log('✅ Saved to localStorage:', this.jsonData);
        
        // Check what's in metadata
        console.log('🔍 DEBUG: metadata.customer:', this.jsonData?.metadata?.customer);
        console.log('🔍 DEBUG: metadata.shipping_address:', this.jsonData?.metadata?.shipping_address);
        
        // ✅ FALLBACK: Extract customer ID from URL if missing from metadata
        let listCreatorId = this.jsonData?.metadata?.customer?.id?.split('/').pop() || null;
        
        if (!listCreatorId) {
          // Try to extract from URL: /pages/checklist-share?type=checklist-{customerId}
          const urlParams = new URLSearchParams(window.location.search);
          const typeParam = urlParams.get('type'); // e.g., "checklist-9483271143712"
          if (typeParam && typeParam.startsWith('checklist-')) {
            listCreatorId = typeParam.replace('checklist-', '');
            console.log('✅ Extracted customer ID from URL as fallback:', listCreatorId);
          } else {
            console.error('❌ Customer ID not found in metadata or URL!');
          }
        }
        
        // ✅ Mark this as a shared checklist session for checkout logic
        localStorage.setItem('shared_checklist_session', JSON.stringify({
          active: true,
          listCreatorId: listCreatorId,
          listCreatorName: this.jsonData?.metadata?.customer?.name || 'unknown'
        }));
        
        // ✅ Set COOKIE so Liquid templates can detect shared guest
        document.cookie = "shared_checklist_guest=true; path=/; max-age=7200; SameSite=Lax";
        console.log('✅ Set cookie: shared_checklist_guest=true');
        
        console.log('✅ Shared checklist session activated. List creator:', 
          this.jsonData?.metadata?.customer?.name || 'unknown');
        
        // ✅ Set global flag immediately
        window.isSharedChecklistGuest = true;
        document.body.classList.add('is-shared-checklist-guest');
        
        // ✅ Force show purple member prices (will run again after products load)
        this.applyMemberPriceUI();
        
        // ✅ Set cart attribute for Shopify Functions to detect shared checklist
        this.setChecklistCartAttribute();
      } else {
        console.warn('⚠️ No JSON data found on page!');
      }
      
      this.accountData = this.jsonData?.metadata || null;
      this.categoriesArray = this.jsonData?.categories || null;

      this.updateAccountInfo();

    } catch (error) {
      console.error('❌ Error parsing JSON:', error);
    }
  }


  async setChecklistCartAttribute() {
    try {
      console.log('🔍 Setting cart attributes for shared checklist member pricing...');
      
      // ✅ CRITICAL: Check if current user is NOT the list creator
      const currentCustomerId = window.currentCustomerId || window.Shopify?.customer?.id || null;
      const listCreatorId = this.jsonData?.metadata?.customer?.id?.split('/').pop() || null;
      const isListCreator = currentCustomerId && listCreatorId && String(currentCustomerId) === String(listCreatorId);
      
      // ✅ Include registry event date if available (ONLY for F&F guests, NOT list creator)
      const eventDate = this.jsonData?.metadata?.registry_event_date;
      const attributes = {
        shared_checklist_member_pricing: 'true'
      };
      
      if (eventDate && !isListCreator) {
        attributes.registry_event_date = eventDate;
        console.log('📅 Including registry event date for F&F guest:', eventDate);
      } else if (isListCreator) {
        console.log('👤 List creator detected - NOT setting registry_event_date');
      }
      
      // ✅ CRITICAL: Include list_owner_id for automatic purchase tracking
      const listOwnerId = this.jsonData?.metadata?.customer?.id?.split('/').pop() || null;
      if (listOwnerId) {
        attributes.list_owner_id = listOwnerId;
        console.log('👤 Including list owner ID for auto-purchase tracking:', listOwnerId);
      }
      
      console.log('📋 Setting cart attributes:', attributes);
      
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          attributes: attributes
        })
      });
      
      if (response.ok) {
        try {
          const result = await response.json();
          console.log('✅ Cart attributes set - guests will get member pricing!');
          console.log('✅ Cart response:', result);
          console.log('✅ Cart attributes now:', result.attributes);
          
          // Verify the attributes were set
          if (!result.attributes?.shared_checklist_member_pricing) {
            console.error('❌ shared_checklist_member_pricing not set!');
          }
          if (eventDate && !result.attributes?.registry_event_date) {
            console.error('❌ registry_event_date attribute not set!');
          }
        } catch (parseError) {
          console.error('❌ Failed to parse cart response:', parseError);
          const text = await response.text();
          console.error('Response text:', text);
        }
      } else {
        console.error('⚠️ Failed to set cart attributes. Status:', response.status);
        const errorText = await response.text();
        console.error('Error response:', errorText);
      }
    } catch (error) {
      console.error('❌ Error setting cart attributes:', error);
    }
  }

  applyMemberPriceUI() {
    console.log('🎨 Applying member price UI for shared checklist guests...');
    
    // ✅ Only show purple member price elements on products with actual promotions
    const memberPriceElements = document.querySelectorAll('.promo-product .mm_cp-member');
    console.log(`Found ${memberPriceElements.length} member price elements (on promo products only)`);
    
    memberPriceElements.forEach((el, index) => {
      el.style.display = 'block';
      el.style.visibility = 'visible';
      el.style.opacity = '1';
    });
    
    // ✅ Also force show sale badges on promo products
    const saleBadges = document.querySelectorAll('.promo-product .mm_cp-card__badge');
    saleBadges.forEach(badge => {
      if (badge.querySelector('.f-badge--sale')) {
        badge.style.display = 'block';
      }
    });
    
    console.log('✅ Member price UI applied - purple prices visible only on discounted products');
  }

  init() {
    this.header = document.querySelector(this.selectors.header);
    this.sideBar = document.querySelector(this.selectors.sideBar);
    this.contentWrapper = document.querySelector(this.selectors.contentWrapper);
    this.setStickyTop();
    window.addEventListener('resize', () => this.setStickyTop());
    this.updateList();
    this.initRemoveButtons();

    // Analytics — Event 20: shared_checklist_opened
    try {
      if (window.ChecklistAnalytics && this.jsonData) {
        const metaCustomer = this.jsonData?.metadata?.customer || {};
        const listCreatorId = (metaCustomer.id || '').toString().split('/').pop() || null;
        const listCreatorName = metaCustomer.first_name || metaCustomer.firstName || null;
        const totalProducts = (this.jsonData.categories || []).reduce((sum, cat) => {
          return sum + (cat.types || []).reduce((s, coll) => s + ((coll.products || []).length), 0);
        }, 0);
        const purchasedProducts = (this.jsonData.categories || []).reduce((sum, cat) => {
          return sum + (cat.types || []).reduce(
            (s, coll) => s + ((coll.products || []).filter((p) => p.markPurchased).length),
            0,
          );
        }, 0);
        const completionPct = totalProducts > 0 ? Math.round((purchasedProducts / totalProducts) * 100) : 0;
        const urlParams = new URLSearchParams(window.location.search);
        window.ChecklistAnalytics.track('shared_checklist_opened', {
          list_creator_id: listCreatorId,
          list_creator_name: listCreatorName,
          checklist_type: urlParams.get('type') || null,
          total_products: totalProducts,
          purchased_products: purchasedProducts,
          completion_percentage: completionPct,
        });
      }
    } catch (e) {}
  }

  checkRemovePermission() {
    const isLoggedIn = this.dataset.isLoggedIn && this.dataset.isLoggedIn !== 'false';

    if (!isLoggedIn) {
      return false;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const typeParam = urlParams.get('type');
    
    if (!typeParam || !typeParam.includes('checklist-')) {
      return false;
    }
    
    const urlCustomerId = typeParam.replace('checklist-', '');
    const currentCustomerId = this.dataset.customerId;
    
    return currentCustomerId && urlCustomerId && currentCustomerId === urlCustomerId;
  }

  addRemoveButton(productElement, category, type) {
    const imageWrapper = productElement.querySelector('.product-card__image-wrapper');
    
    if (!imageWrapper) return;
    
    const removeButton = document.createElement('button');
    removeButton.className = 'product-card__remove-btn';
    removeButton.setAttribute('aria-label', 'Remove from checklist');
    removeButton.setAttribute('remove-product-share', '');
    removeButton.dataset.categoryId = category.id || '';
    removeButton.dataset.collectionId = type.id || '';
    removeButton.dataset.collectionHandle = type.handle || '';
    removeButton.style.cssText = 'position: absolute; top: 8px; right: 8px; z-index: 10; background: rgba(220, 38, 38, 0.9); color: white; width: 24px; height: 24px; min-width: 24px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: bold; border: none; cursor: pointer; transition: all 0.2s ease; padding: 0;';
    removeButton.textContent = '×';
    
    // Add hover effect
    removeButton.addEventListener('mouseenter', () => {
      removeButton.style.background = 'rgba(220, 38, 38, 1)';
      removeButton.style.transform = 'scale(1.1)';
    });
    
    removeButton.addEventListener('mouseleave', () => {
      removeButton.style.background = 'rgba(220, 38, 38, 0.9)';
      removeButton.style.transform = 'scale(1)';
    });
    
    imageWrapper.appendChild(removeButton);
  }

  initRemoveButtons() {
    // Handle remove buttons for share checklist products
    document.addEventListener('click', async (e) => {
      if (e.target.matches('[remove-product-share]') || e.target.closest('[remove-product-share]')) {
        e.preventDefault();
        e.stopPropagation();
        
        const removeBtn = e.target.closest('[remove-product-share]');
        const productItem = removeBtn.closest('li');
        const variantId = productItem.dataset.id;
        
        // Get collection info from the remove button data attributes
        const categoryId = removeBtn.dataset.categoryId;
        const collectionId = removeBtn.dataset.collectionId;
        const collectionHandle = removeBtn.dataset.collectionHandle;
        
        const itemData = {
          collection_handle: collectionHandle,
          collection_id: collectionId,
          category_id: categoryId,
          customer_id: this.dataset.customerId,
          variant_id: variantId
        };
        
        try {
          // Add loading state
          removeBtn.style.opacity = '0.5';
          removeBtn.disabled = true;
          removeBtn.style.pointerEvents = 'none';
          
          const response = await fetch(
            'https://app.motsesim.co.il/api/delete/checklist?shop=motsesim.myshopify.com&page=account',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(itemData),
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();
          
          if (result.success || result.status === 200) {
            // Update the local JSON data to reflect the removal
            this.updateLocalJsonData(variantId, categoryId, collectionId);
            
            // Remove all instances of this product from all tabs
            this.removeProductFromAllTabs(variantId);
            
            // Update tab counts
            this.updateTabCounts();
            
          } else {
            throw new Error('Failed to delete item from server');
          }
          
        } catch (error) {
          console.error('Error removing item:', error);
          // Reset button state on error
          removeBtn.style.opacity = '1';
          removeBtn.disabled = false;
          removeBtn.style.pointerEvents = 'auto';
          alert('Failed to remove item. Please try again.');
        }
      }
    });
  }

  updateLocalJsonData(variantId, categoryId, collectionId) {
    if (!this.jsonData || !this.categoriesArray) return;
    
    // Find and remove the product from the local data structure
    this.categoriesArray.forEach(category => {
      if (category.id === categoryId) {
        category.types?.forEach(type => {
          if (type.id === collectionId) {
            // Remove the product from the products array
            if (type.products) {
              type.products = type.products.filter(product => 
                product.id !== variantId
              );
              // Update product count
              type.productCount = type.products.length;
            }
          }
        });
        
        // Update category product count
        category.productCount = category.types?.reduce((total, type) => {
          return total + (type.productCount || 0);
        }, 0) || 0;
      }
    });
    
    // Update localStorage with the modified data
    localStorage.setItem('customer_data_json', JSON.stringify(this.jsonData));
  }

  removeProductFromAllTabs(variantId) {
    // Remove from all tabs: main category tab, all-products tab, and purchased tab
    const allProductItems = document.querySelectorAll(`li[data-id="${variantId}"]`);
    
    allProductItems.forEach(item => {
      // Add removal animation
      item.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out';
      item.style.opacity = '0';
      item.style.transform = 'scale(0.9)';
      
      setTimeout(() => {
        item.remove();
      }, 300);
    });
    
    // Remove from purchasedProducts object
    if (this.purchasedProducts[variantId]) {
      delete this.purchasedProducts[variantId];
    }
  }

  updateTabCounts() {
    // Update tab button counts
    const tabs = document.querySelectorAll('[category-tab-btn]');
    
    tabs.forEach(tab => {
      const handle = tab.dataset.handle;
      
      if (handle === 'all-products') {
        const allProductsCount = this.categoriesArray.reduce((sum, category) => {
          return sum + category.types?.reduce((tSum, type) => tSum + (type.products?.length || 0), 0);
        }, 0);
        tab.innerHTML = `כל המוצרים (${allProductsCount})`;
      } else if (handle === 'purchased') {
        const purchasedCount = Object.keys(this.purchasedProducts).length;
        tab.innerHTML = `נרכש (${purchasedCount})`;
      } else {
        // Find specific category count
        const category = this.categoriesArray.find(cat => cat.name?.toLowerCase() === handle);
        if (category) {
          tab.innerHTML = `${category.name} (${category.productCount || 0})`;
        }
      }
    });
  }

  updateAccountInfo() {
    if (!this.accountData || !this.accountData.customer) { console.error('Customer metadata is missing.'); return; }

    const customer = this.accountData.customer;
    const customerSideBarElement = this.querySelector(this.selectors.sideBar);

    if (!customerSideBarElement) { console.error('Customer container element not found.'); return; }

    let content = customerSideBarElement.innerHTML;
    const isoDate = this.accountData.date;

    let formattedDate = '';
    if (isoDate) { 
      const dateObj = new Date(isoDate); 
      const day = String(dateObj.getDate()).padStart(2, '0');
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const year = dateObj.getFullYear();      
      formattedDate = `${day}/${month}/${year}`; 
    }

    // Construct customer name from firstName and lastName if name is not available
    const customerName = customer.name || 
                         (customer.firstName && customer.lastName ? `${customer.firstName} ${customer.lastName}` : '') ||
                         (customer.first_name && customer.last_name ? `${customer.first_name} ${customer.last_name}` : '') ||
                         '';
    
    content = content.replaceAll('{customer_name}', customerName);
    content = content.replaceAll('{account_creation_date}', formattedDate || '');
    // ✅ Always use grey avatar - never use customer.image from metafield
    content = content.replaceAll('{account_image_url}', 'https://cdn.shopify.com/s/files/1/0925/2516/6880/files/c8d7f95f7a41608ae93c2806ac8ad554.webp?v=1765748217');
    // ✅ Remove hardcoded developer name - use empty string if no partner
    content = content.replaceAll('{partner}', this.accountData.partner || '');
    
    // ✅ Add registry event date
    const eventDate = this.accountData?.registry_event_date;
    console.log('🔍 Registry event date from accountData:', eventDate);
    
    if (eventDate) {
      // Format date as DD/MM/YYYY (with slashes, not dots)
      const dateObj = new Date(eventDate);
      const day = String(dateObj.getDate()).padStart(2, '0');
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const year = dateObj.getFullYear();
      const formattedEventDate = `${day}/${month}/${year}`;
      
      console.log('✅ Formatted event date:', formattedEventDate);
      content = content.replaceAll('{registry_event_date}', formattedEventDate);
      content = content.replaceAll('{registry_event_date_display}', 'flex');
    } else {
      console.log('⚠️ No registry event date found');
      content = content.replaceAll('{registry_event_date}', '');
      content = content.replaceAll('{registry_event_date_display}', 'none');
    }

    customerSideBarElement.innerHTML = content;
    
    // ✅ Keep the collapsible open by default after HTML replacement
    const collapseElement = customerSideBarElement.querySelector('.collapse');
    const collapseButton = customerSideBarElement.querySelector('.collapse-button');
    const collapseContent = customerSideBarElement.querySelector('.collapse-content');
    
    if (collapseElement && !collapseElement.classList.contains('active')) {
      collapseElement.classList.add('active');
      if (collapseButton) collapseButton.classList.add('active');
      if (collapseContent) {
        collapseContent.classList.add('active');
        collapseContent.style.maxHeight = '1000px';
      }
    }
    
    if (customer.id) {
      const fullGid = customer.id;
      const customerId = fullGid.split('/').pop();
      this.dataset.customerId = customerId;
    } else {
      console.warn('⚠️ Customer ID not found in metadata');
    }
  }

  setStickyTop() { if (this.header) { this.header.offsetHeight + 30; } }

  async updateList() {
    if (!Array.isArray(this.categoriesArray) || this.categoriesArray.length === 0) {
      console.error('No categories available to update the list.');
      return;
    }

    const categoriesTabsScript = this.querySelector(this.selectors.categoriesTabs);
    const checklistLists = this.querySelector('[registry-lists]');
    const productsTabsContent = this.querySelector('[registry-lists-products]');

    if (!categoriesTabsScript || !checklistLists || !productsTabsContent) {
      console.error('Required elements for list rendering are missing.');
      return;
    }

    const tabsTemplateHtml = categoriesTabsScript.textContent;
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = tabsTemplateHtml;

    this.allProducts = await this.getAllProducts();
    const productIDs = this.collectProductIDs(this.categoriesArray, 49);

    this.createAllProductsTab(checklistLists, productsTabsContent, productIDs);

    let hasAnyCategory = false;

    for (const category of this.categoriesArray) {
      const hasProducts = category.types?.some(type => type.productCount > 0);
      if (category.productCount > 0 && hasProducts) {
        hasAnyCategory = true;

        const listItem = tempContainer.firstElementChild.cloneNode(true);
        listItem.innerHTML = this.populateTemplate(listItem.innerHTML, { '{list_name}': category.name || '', '{list_handle}': category.name?.toLowerCase() || '', '{products_count}': `(${category.productCount || 0})` });
        checklistLists.appendChild(listItem);

        const { tabContent } = this.createCategoryTabContent({ handle: category.name.toLowerCase(), id: category.id });

        productsTabsContent.appendChild(tabContent);
      }
    }
    this.productsData = await this.fetchProductData(productIDs);
    const variantIds = this.productsData.map(product => product.id);
    await this.handleVariantInfo(variantIds);
    this.createPurchasedTab();

    const registryTabEle = document.querySelector('reg-checklist-tabs');
    registryTabEle?.initSelectors?.();

    if (!hasAnyCategory) { checklistLists.innerHTML = `<p class="no-prod-found">אין מוצרים רשומים ברשימת הבדיקה. אנא צור קשר עם הבעלים של רשימת המשימות כדי לעדכן אותו.</p>`; }
  }

  async getAllProducts() {
    const result = [];
    for (const category of this.categoriesArray) {
      for (const type of category.types || []) {
        for (const product of type.products || []) {
          result.push({
            category_id: category.id,
            collection_handle: type.handle,
            id: product.id,
            handle: product.handle,
            markPurchased: product.markPurchased
          });
        }
      }
    }
    return result;
  }

  collectProductIDs(categories, limit) {
    const ids = [];
    for (const category of categories) {
      for (const type of category.types || []) {
        for (const product of type.products || []) {
          if (ids.length >= limit) return ids;
          if (product.id) ids.push(product.id);
        }
      }
      if (ids.length >= limit) break;
    }
    return ids;
  }

  createAllProductsTab(checklistLists, productsTabsContent, products) {
    if (!products.length) return;
    const allCategoriestotalProducts = this.categoriesArray.reduce((sum, category) => { return sum + category.types?.reduce((tSum, type) => tSum + (type.products?.length || 0), 0); }, 0);
    const tab = document.createElement('li');
    tab.innerHTML = `<button class="btn btn--secondary active" data-handle="all-products" category-tab-btn aria-selected="true">כל המוצרים (${allCategoriestotalProducts})</button>`;
    checklistLists.appendChild(tab);

    const { tabContent } = this.createCategoryTabContent({ handle: 'all-products', id: 'all-products' });

    productsTabsContent.appendChild(tabContent);
  }

  createCategoryTabContent({ handle, id }) {
    const tabContent = document.createElement('div');
    tabContent.dataset.handle = handle;
    tabContent.dataset.id = id;
    tabContent.setAttribute('category-tab-content', '');
    if (handle === 'all-products') { tabContent.classList.add('active'); }

    const productList = document.createElement('ul');
    productList.classList.add('grid-list', 'products-list', 'f-grid', 'md:f-grid-3-cols', 'xl:f-grid-3-cols', 'f-grid--gap-medium', 'f-grid-2-cols', 'active');
    productList.setAttribute('data-category-id', id);

    const loader = this.createLoader();

    const fragment = document.createDocumentFragment();
    fragment.appendChild(productList);
    tabContent.appendChild(fragment);
    tabContent.appendChild(loader);

    return { tabContent, productList };
  }

  createLoader() {
    const loader = document.createElement('div');
    loader.classList.add('loading__spinner');
    loader.innerHTML = `<svg aria-hidden="true" focusable="false" class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle></svg>`;
    return loader;
  }



  async fetchProductData(ids) {
    const url = 'https://app.motsesim.co.il/api/get/products?shop=motsesim.myshopify.com';

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ variantIds: ids })
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const data = await response.json();
      // console.log(data, "THIS IS DATA");

      // ✅ FIX: Filter out null/invalid variants and add null checks
      const cleanedVariants = (data.variants || [])
        .filter(variant => variant && variant.id) // Filter out null variants
        .map(variant => ({
        ...variant,
          id: variant.id ? variant.id.split('/').pop() : null,
        product: {
          ...variant.product,
            id: variant.product?.id ? variant.product.id.split('/').pop() : null
        }
        }))
        .filter(variant => variant.id); // Filter out variants with null IDs after cleaning

      console.log(`✅ Cleaned ${cleanedVariants.length} valid variants from ${data.variants?.length || 0} total`);

      return cleanedVariants;
    } catch (error) {
      console.error('Error fetching variants:', error);
      return [];
    }
  }


  async handleVariantInfo(variantIds) {
    // console.log('Logging Product Category Info for Variant IDs:', variantIds);
    const productsTabsContent = this.querySelector('[registry-lists-products]');
    
    // ✅ FIX: Remove loading spinners even if there's an error
    const removeAllSpinners = () => {
      productsTabsContent?.querySelectorAll('[category-tab-content] > .loading__spinner')?.forEach(spinner => spinner.remove());
    };
    
    if (!this.productsData?.length) { 
      console.error('No products found in productsData.'); 
      removeAllSpinners();
      return; 
    }
    if (!this.categoriesArray?.length) { 
      console.error('No categories found in categoriesArray.'); 
      removeAllSpinners();
      return; 
    }
    if (!productsTabsContent) { 
      console.error('Products tabs content element not found.'); 
      return; 
    }

    // ✅ FIX: Also populate all-products tab
    const allProductsTab = productsTabsContent?.querySelector('[data-handle="all-products"]');
    const allProductsList = allProductsTab?.querySelector('.products-list');

    for (const category of this.categoriesArray) {
      for (const type of category.types || []) {
        const matchingProducts = (type.products || []).filter(product => variantIds.includes(product.id));

        for (const product of matchingProducts) {
          const variant = this.productsData.find(v => v.id === product.id);
          if (variant) {
            // console.log({
            //   category,
            //   variantId: product.id,
            //   categoryName: category.name,
            //   collectionName: type.name,
            //   collectionHandle: type.handle,
            //   variantObject: variant
            // });

            const tabContent = productsTabsContent?.querySelector(`[data-handle="${category.name?.toLowerCase()}"]`);
            const productList = tabContent?.querySelector('.products-list');
            
            // Populate category-specific tab
            if (productList) {
            this.populateProducts([variant], category, type, productList, 1);
            }
            
            // ✅ FIX: Also populate all-products tab if not already rendered
            if (allProductsList && !allProductsList.querySelector(`li[data-id="${variant.id}"]`)) {
              this.populateProducts([variant], category, type, allProductsList, 1);
            }

          } else {
            console.warn(`Variant not found in productsData for ID: ${product.id}`);
          }
        }
      }
    }
    
    // ✅ FIX: Remove spinner from all-products tab after population
    allProductsTab?.querySelector('.loading__spinner')?.remove();
  }

  async handleTabChange(tab, handle) {
    console.log(tab, handle, "HANDLE");
    const categoryId = tab.dataset.id;

    // Get rendered product IDs from the DOM
    const renderedProductIds = Array.from(tab.querySelectorAll('li[data-id]')).map(li => li.getAttribute('data-id'));
    const unrenderedProductIds = this.findUnrenderedProducts(this.categoriesArray, categoryId, renderedProductIds);
    // console.log(`rendered Product IDs:`, renderedProductIds);
    // console.log(`Unrendered Product IDs:`, unrenderedProductIds);
    // console.log(`Number of Unrendered Products:`, unrenderedProductIds.length);
    
    // ✅ FIX: Handle "all-products" tab loading
    if (categoryId === 'all-products') {
      // Check if products are already rendered
      if (!tab.querySelector('li[data-id]') && unrenderedProductIds.length > 0) {
        console.log('🔄 Loading all products...', unrenderedProductIds.length, 'products');
        this.productsData = await this.fetchProductData(unrenderedProductIds);
        const variantIds = this.productsData.map(product => product.id).filter(id => id); // Filter out null IDs
        if (variantIds.length > 0) {
          await this.handleVariantInfo(variantIds);
        } else {
          // Remove spinner if no valid products
          tab.querySelector('.loading__spinner')?.remove();
          console.warn('⚠️ No valid products to render for all-products tab');
        }
      } else {
        // Products already rendered, just remove spinner
        tab.querySelector('.loading__spinner')?.remove();
      }
    } else {
      if (!tab.querySelector('li[data-id]') && unrenderedProductIds.length > 0) {
        this.productsData = await this.fetchProductData(unrenderedProductIds);
        const variantIds = this.productsData.map(product => product.id).filter(id => id); // Filter out null IDs
        if (variantIds.length > 0) {
        await this.handleVariantInfo(variantIds);
        } else {
          // Remove spinner if no valid products
          tab.querySelector('.loading__spinner')?.remove();
        }
      }
      // Handle rendering for specific category
    }
  }

  findUnrenderedProducts(categoriesArray, categoryId, renderedProductIds) {
    let unrenderedProductIds = [];
    if (categoryId === 'all-products') {
      // Collect all unrendered products across all categories
      unrenderedProductIds = categoriesArray.flatMap(category =>
        category.types.flatMap(type =>
          type.products
            .filter(product => !renderedProductIds.includes(product.id))
            .map(product => product.id)
        )
      );
    } else {
      // Find the specific category and collect its unrendered products
      const category = categoriesArray.find(cat => cat.id.toString() === categoryId);
      if (category) {
        unrenderedProductIds = category.types.flatMap(type =>
          type.products
            .filter(product => !renderedProductIds.includes(product.id))
            .map(product => product.id)
        );
      }
    }
    return unrenderedProductIds;
  }

  createPurchasedTab() {
    const checklistLists = this.querySelector('[registry-lists]');
    const productsTabsContent = this.querySelector('[registry-lists-products]');

    const purchasedCount = this.categoriesArray.reduce((count, category) => {
      return (
        count +
        category.types.reduce((typeCount, type) => {
          return (
            typeCount +
            type.products.reduce((productCount, product) => {
              return productCount + (product.markPurchased ? 1 : 0);
            }, 0)
          );
        }, 0)
      );
    }, 0);

    // Create tab button
    const listItem = document.createElement('li');
    listItem.innerHTML = `<button class="btn btn--secondary" data-handle="purchased" category-tab-btn>נרכש (${purchasedCount})</button>`;
    checklistLists.appendChild(listItem);

    // Create tab content
    const categoryTabContent = document.createElement('div');
    categoryTabContent.dataset.handle = 'purchased';
    categoryTabContent.setAttribute('category-tab-content', '');

    const fragment = document.createDocumentFragment();
    const productList = document.createElement('ul');
    productList.classList.add('grid-list', 'products-list', 'f-grid', 'md:f-grid-3-cols', 'xl:f-grid-3-cols', 'f-grid--gap-medium', 'f-grid-2-cols');
    fragment.appendChild(productList);
    // console.log(this.purchasedProducts, "LSISR");

    for (const productKey in this.purchasedProducts) {
      productList.appendChild(this.purchasedProducts[productKey]);
    }

    categoryTabContent.appendChild(fragment);
    productsTabsContent.appendChild(categoryTabContent);
  }


  populateProducts(variants, category, type, productList, limit) {
    const productListScript = document.querySelector('#product-item-script');
    const allProductsContent = this.querySelector('[data-handle="all-products"] > ul');
    const purchasedList = this.querySelector('[registry-lists-products] > [data-handle="purchased"] > ul');

    if (!productListScript) {
      console.error('#product-item-script not found.');
      return;
    }

    const templateHTML = productListScript.textContent;
    const canRemoveItems = this.checkRemovePermission();

    variants?.forEach((variant, index) => {
      const product = variant.product;

      // Find the corresponding product in this.categoriesArray to get markPurchased
      const foundProduct = this.categoriesArray
        .flatMap(cat => cat.types.flatMap(t => t.products))
        .find(p => p.id === variant.id);

      let markPurchased = false;
      if (foundProduct) {
        markPurchased = foundProduct.markPurchased || false;
      } else {
        console.warn(`Product with variant ID ${variant.id} not found in categoriesArray`);
      }

      const clubPrice = variant.price;
      const fullPrice = variant.compareAtPrice || 0;
      const hasMemberPrice = fullPrice > 0 && fullPrice > clubPrice;

      // Replace placeholders in the template
      let productHTML = templateHTML
        .replaceAll('{product_id}', product.id)
        .replaceAll('{variant_id}', variant.id)
        .replaceAll('{product_handle}', product.handle)
        .replaceAll('{category_id}', category.id || '')
        .replaceAll('{collection_id}', type.id || '')
        .replaceAll('{collection_name}', type.name || '')
        .replaceAll('{collection_handle}', type.handle || '')
        .replaceAll('{customer_name}', this.accountData?.customer?.name || '')
        .replaceAll('{handle}', product.handle)
        .replaceAll('{product_image}', product.featuredMedia.preview.image.url)
        .replaceAll('{variant_price}', clubPrice + window.routes.currency)
        .replaceAll('{{amount}}', '')
        .replaceAll('{product_title}', product.title)
        .replaceAll('{product_vendor}', product.vendor)
        .replaceAll('{product_type}', product.productType)
        .replaceAll(
                      '{variant_compare_at_price}',
                      hasMemberPrice
                        ? window.routes.currency.replace('{{amount}}', fullPrice)
                        : ''
                    )
        .replaceAll('{promo_product}', hasMemberPrice ? "promo-product" : '')
        .replaceAll(
          '{sale_off}',
          hasMemberPrice
            ? (() => {
                const discountDiff = fullPrice - clubPrice;
                const discountTenths = Math.floor((discountDiff * 1000) / fullPrice);
                const discountWhole = Math.floor(discountTenths / 10);
                const discountDecimal = discountTenths % 10;
                return discountDecimal >= 6 ? discountWhole + 1 : discountWhole;
              })()
            : ''
        )
        .replaceAll(
          '{variant_compare_at_price != variant_price ? \'block\' : \'none\'}',
          hasMemberPrice ? 'block' : 'none'
        )
        .replaceAll(
          '{variant_compare_at_price == variant_price ? \'block\' : \'none\'}',
          hasMemberPrice ? 'none' : 'block'
        );            

      const wrapper = document.createElement('div');
      wrapper.innerHTML = productHTML;

      const productElement = wrapper.firstElementChild;
      if (!productElement) return;

      productElement.dataset.categoryId = category.id || '';
      productElement.dataset.collectionId = type.id || '';
      productElement.dataset.collectionHandle = type.handle || '';

      // ✅ Add promotion_type property if variant has a member discount.
      // Works for both pricing models — uses resolved variantMemberPrice (above).
      if (hasMemberPrice) {
        const form = productElement.querySelector('form[data-type="add-to-cart-form"]');
        if (form) {
          const promotionInput = document.createElement('input');
          promotionInput.type = 'hidden';
          promotionInput.name = 'properties[_promotion_type]';
          promotionInput.value = 'price_discount';
          promotionInput.className = 'product-variant-prop';
          promotionInput.dataset.name = '_promotion_type';
          form.appendChild(promotionInput);
          console.log(`✅ Added _promotion_type=price_discount to variant ${variant.id}`);
        }
      }

      // Add remove button if user has permission
      if (canRemoveItems) {
        this.addRemoveButton(productElement, category, type);
      }

      // Add purchased tag and class if markPurchased is true
      if (markPurchased) {
        const productWrapper = productElement.querySelector('.product-card__wrapper');
        if (productWrapper) {
          productWrapper.classList.add('product-card__wrapper--purchased');
          productWrapper.innerHTML += '<span class="purchased-label">נרכש</span>';
        } else {
          console.warn(`.product-card__wrapper not found in productElement for variant ${variant.id}`);
        }
      }

      // Append to the main product list and all-products tab
      productList.appendChild(productElement);
      
      const clonedForAll = productElement.cloneNode(true);
      if (canRemoveItems) {
        this.addRemoveButton(clonedForAll, category, type);
      }
      allProductsContent.appendChild(clonedForAll);

      // Add to purchasedProducts and purchased tab if markPurchased is true
      if (markPurchased) {
        const purchasedEle = productElement.cloneNode(true);
        if (canRemoveItems) {
          this.addRemoveButton(purchasedEle, category, type);
        }
        this.purchasedProducts[variant.id] = purchasedEle;
        if (purchasedList) { purchasedList.appendChild(purchasedEle); }
      }
    });

    const totalProducts = category?.types?.reduce((sum, type) => { return sum + (type.products?.length || 0); }, 0);
    const allCategoriestotalProducts = this.categoriesArray.reduce((sum, category) => { return sum + category.types?.reduce((tSum, type) => tSum + (type.products?.length || 0), 0); }, 0);
    const renderedProducts = document.querySelectorAll('[category-tab-content] li[data-id]').length;
    const parentEle = productList?.parentElement;
    
    // ✅ Apply member price UI after products are rendered
    if (window.isSharedChecklistGuest) {
      this.applyMemberPriceUI();
    }
    if (!parentEle) return;

    if (productList?.children?.length === totalProducts) {
      parentEle.dataset.rendered = 'true';
    }
    parentEle.querySelector('[category-tab-content] > .loading__spinner')?.remove();
    allProductsContent?.parentElement?.querySelector('[category-tab-content] > .loading__spinner')?.remove();
  }

  populateTemplate(template, replacements) { return Object.entries(replacements).reduce((result, [key, value]) => result.replaceAll(key, value), template); }

}

customElements.define('checklist-share-component', ChecklistShareComponent);



// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
class RegChecklistTabs extends HTMLElement {
  constructor() {
    super();
    this.selectors = { tabs: '[category-tab-btn]', content: '[category-tab-content]', btnPurchase: '[btn-purchase]', purchaseHtmlScript: '#product-purchase-gift-html', flyoutBody: '[flyout-modal-content]', flyoutFooter: '[flyout-modal-footer]', flyoutModal: 'flyout-modal-js', flyoutModalHeading: '[flyout-modal-head] h2' };
  }

  initSelectors() {
    this.tabs = this.querySelectorAll(this.selectors.tabs);
    this.tabsContent = this.querySelectorAll(this.selectors.content);
    this.btnPurchase = this.querySelectorAll(this.selectors.btnPurchase);
    this.initEvents();
    this.toggleTab(this.tabs[0]);
  }

  initEvents() {
    this.tabs?.forEach(btn => { btn?.addEventListener('click', () => { this.toggleTab(btn); }); });
    this.btnPurchase?.forEach(btn => { btn?.addEventListener('click', () => { this.handlePurchaseHtml(btn); }) });
  }

  toggleTab(button) {
    const handle = button.dataset.handle;
    const tabContent = this.querySelector(`[category-tab-content][data-handle="${handle}"]`);
    const mainComponent = this.closest('checklist-share-component');

    if (tabContent) {
      this.tabs?.forEach(btn => btn.classList.remove('active'));
      this.tabsContent?.forEach(content => content.classList.remove('active'));

      button.classList.add('active');
      tabContent.classList.add('active');
      mainComponent.handleTabChange(tabContent, handle);
    }
  }

  handlePurchaseHtml(button) {
    // ✅ Get customer ID from URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const checklistParam = urlParams.get('type'); // e.g., "checklist-9483271143712"
    const customerId = checklistParam ? checklistParam.replace('checklist-', '') : '';
    
    const dataJson = {
      collection_id: button.closest('li')?.dataset.collectionId,
      category_id: button.closest('li')?.dataset.categoryId,
      collection_handle: button.closest('li')?.dataset.collectionHandle,
      variant_id: button.closest('li')?.dataset.id,
      customer_id: customerId,  // ✅ Now gets from URL!
      product_title: button.closest('li')?.querySelector('.product-card__title')?.textContent || '',
      product_image: button.closest('li')?.querySelector('.product-card__media img')?.src || '',
    };

    const variantId = button.parentElement?.querySelector('form .product-variant-id');
    const scriptHtml = document.querySelector(this.selectors.purchaseHtmlScript).innerHTML;
    const flyoutModal = document?.querySelector(this.selectors.flyoutModal);
    const flyoutBody = flyoutModal?.querySelector(this.selectors.flyoutBody);
    const flyoutFooter = flyoutModal?.querySelector(this.selectors.flyoutFooter);
    const flyoutModalHeading = flyoutModal?.querySelector(this.selectors.flyoutModalHeading);

    flyoutFooter.innerHTML = '';
    flyoutBody.innerHTML = '';
    flyoutModalHeading.textContent = 'האם כבר רכשתם מתנה זאת לכבוד הלידה המתקרבת?';

    const parser = new DOMParser();
    const doc = parser.parseFromString(scriptHtml, 'text/html');
    const element = doc.querySelector('product-purchased-gift');
    element.dataset.variantId = variantId.value;
    element.jsonData = dataJson;
    if (element) {
      flyoutBody.appendChild(element);
    }

    flyoutModal.openFlyout();
  }

}
customElements.define('reg-checklist-tabs', RegChecklistTabs);
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 

class checklistProductCard extends HTMLElement {
  constructor() {
    super();
    this.selectors = {};
    this.initialize();
  }

  initialize() {
    this.selectors = {
      purchasedCheckbox: this.querySelector('.mark-purchased-checkbox'),
      giftCheckbox: this.querySelector('.gift-note-checkbox'),
      purchaseLocation: this.querySelector('.purchase-location-input'),
      giftNoteInputs: this.querySelector('.gift-note-inputs'),
      giftNoteText: this.querySelector('#gift-note-text')
    };

    this.setupEventListeners();
  }

  setupEventListeners() {
    const {
      purchasedCheckbox,
      giftCheckbox,
      purchaseLocation,
      giftNoteInputs,
      giftNoteText
    } = this.selectors;

    purchasedCheckbox.addEventListener('change', () => {
      if (purchasedCheckbox.checked) {
        purchaseLocation.classList.add('expanded');
        purchaseLocation.style.maxHeight = `${purchaseLocation.scrollHeight}px`;

        // Analytics — Event 22: mark_as_purchased_clicked
        try {
          if (window.ChecklistAnalytics) {
            const host = this.closest('product-purchased-gift') || this;
            const jsonData = (host && host.jsonData) || {};
            window.ChecklistAnalytics.track('mark_as_purchased_clicked', {
              product_id: jsonData.product_id || null,
              variant_id: jsonData.variant_id || null,
              product_title: jsonData.product_title || null,
              category_id: jsonData.category_id || null,
              collection_id: jsonData.collection_id || null,
            });
          }
        } catch (e) {}
      } else {
        purchaseLocation.classList.remove('expanded');
        purchaseLocation.style.maxHeight = '0';
      }
    });

    giftCheckbox.addEventListener('change', () => {
      if (giftCheckbox.checked) {
        giftNoteInputs.classList.add('expanded');
        giftNoteInputs.style.maxHeight = `${giftNoteInputs.scrollHeight}px`;

        const form = this.parentElement.closest('form');
        if (form) {
          let hiddenInput = form.querySelector('input[name="gift-note-hidden"]');
          if (!hiddenInput) {
            hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'gift-note-hidden';
            form.appendChild(hiddenInput);
          }
        }
      } else {
        giftNoteInputs.classList.remove('expanded');
        giftNoteInputs.style.maxHeight = '0';

        const form = this.parentElement.closest('form');
        if (form) {
          const hiddenInput = form.querySelector('input[name="gift-note-hidden"]');
          if (hiddenInput) {
            hiddenInput.remove();
          }
        }
      }
    });

    giftNoteText?.addEventListener('input', () => {
      const form = this.parentElement.closest('form');
      if (form) {
        const hiddenInput = form.querySelector('input[name="gift-note-hidden"]');
        if (hiddenInput) {
          hiddenInput.value = giftNoteText.value;
        }
      }
    });
  }
}

customElements.define('checklist-prod-card', checklistProductCard);
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 


class FlyoutModalJs extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      toggleBtn: '[flyout-modal-toggle]',
      head: '[flyout-modal-head]',
      content: '[flyout-modal-content]',
      footer: '[flyout-modal-footer]',
      flyout: '.flyout-modal'
    };

    this.init();
  }

  init() {
    this.flyout = this.querySelector(this.selectors.flyout);
    this.toggleBtn = this.querySelectorAll(this.selectors.toggleBtn);


    this.toggleBtn?.forEach(btn => {
      btn?.addEventListener('click', () => {
        if (this.flyout.classList.contains('active')) {
          this.closeFlyout();
        } else {
          this.openFlyout();
        }
      });
    });
  }

  openFlyout() {
    this.flyout.classList.add('active');
    setTimeout(() => {
      this.flyout.classList.add('active--transform');
    }, 10);
    document.body.style.overflow = 'hidden';
  }

  closeFlyout() {
    this.flyout.classList.remove('active--transform');
    setTimeout(() => {
      this.flyout.classList.remove('active');
    }, 220);
    document.body.style.overflow = '';
  }

}
customElements.define('flyout-modal-js', FlyoutModalJs);


class ListShareElement extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      container: '[list-share-container]',
      shareBtn: '[list-share-btn]',
      shareOption: '[list-share-option]',
      inputs: '[list-share-input]',
      successBox: '.success-box',
      errorBox: '.error-box',
      flyoutModal: 'flyout-modal-js',
      submitBtn: '[list-share-submit]',
      cancelBtn: '[list-share-cancel]',
      shippingContainer: '[list-share-shipping-info]',
    };
    this.formData = null;
  }

  connectedCallback() {
    setTimeout(() => {
      this.cacheElements();
      this.bindEvents();
    }, 100);
  }

  cacheElements() {
    this.container = this.querySelector(this.selectors.container);
    this.shareBtn = this.querySelector(this.selectors.shareBtn);
    this.shareOption = this.querySelector(this.selectors.shareOption);
    this.inputs = this.querySelectorAll(this.selectors.inputs);
    this.successBox = this.querySelector(this.selectors.successBox);
    this.errorBox = this.querySelector(this.selectors.errorBox);
    this.submitBtn = this.closest(this.selectors.flyoutModal)?.querySelector(this.selectors.submitBtn);
    this.cancelBtn = this.closest(this.selectors.flyoutModal)?.querySelector(this.selectors.cancelBtn);
    this.shippingContainer = this.querySelector(this.selectors.shippingContainer);
    this.flyoutModal = this.closest(this.selectors.flyoutModal);
  }

  bindEvents() {
    if (this.shareBtn) { this.shareBtn.addEventListener('click', () => this.copyToClipboard()); }
    this.submitBtn?.addEventListener('click', () => this.handleAddress());
    this.cancelBtn?.addEventListener('click', () => this.flyoutModal.closeFlyout());
  }

  copyToClipboard() {
    const url = this.shareBtn?.getAttribute('data-url');

    if (!url) {
      console.warn('No URL found in data-url attribute');
      return;
    }

    navigator.clipboard.writeText(window.location.origin + url).then(() => {
      if (this.successBox) {
        this.successBox.classList.remove('hidden');
        setTimeout(() => {
          this.successBox.classList.add('hidden');
        }, 5000);
      }
    }).catch(err => {
      console.error('Failed to copy link:', err);
    });
  }

  handleAddress() {
    // ⚠️ SECURITY: Only allow list owner to update shipping address
    const isOwner = this.dataset.isOwner === 'true';
    if (!isOwner) {
      console.warn('❌ Only list owner can update shipping address');
      alert('רק בעל הרשימה יכול לערוך את כתובת המשלוח');
      return;
    }

    this.formData = this.formData || { customer: {} };

    this.inputs?.forEach((input) => {
      const name = input.dataset.name || input.name || '';
      const value = input.dataset.value || input.value || '';
      if (!name || !value) return;
      this.formData.customer[name] = value;
    });

    const customerId = this.dataset.id;
    const addressData = {
      customer_id: customerId,
      shipping_address: this.formData.customer
    };

    this.submitBtn.classList.add('btn--loading');
    this.submitBtn.disabled = true;
    this.sendCustomerData(addressData);
  }

  async sendCustomerData(data) {

    try {
      const response = await fetch('https://app.motsesim.co.il/api/update/shipping?shop=motsesim.myshopify.com', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.status === 200) {
        if (this.container.classList.contains('hidden')) {
          this.container.classList.remove('hidden');
          this.shippingContainer.classList.add('hidden');
          this.submitBtn.parentElement.remove();
        }
        const storedData = localStorage.getItem('customer_data_json');
        let customerData = storedData ? JSON.parse(storedData) : {};
        if (customerData.metadata && (!customerData.metadata.shipping_address || Object.keys(customerData.metadata.shipping_address).length === 0)) {
          customerData.metadata.shipping_address = data.shipping_address;
        }
        localStorage.setItem('customer_data_json', JSON.stringify(customerData));
      }
    } catch (error) {
      console.error('Error sending customer data:', error);
    }
  }
}

customElements.define('list-share-element', ListShareElement);

class CustomerAccountBanner extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      shareChecklistHtml: '#share-checklist-html',
      customerEditDetailHtml: '#customer-details-edit-html',
      flyoutBody: '[flyout-modal-content]',
      flyoutFooter: '[flyout-modal-footer]',
      flyoutModal: 'flyout-modal-js',
      flyoutModalHeading: '[flyout-modal-head] h2',
      guestViewBtn: '[guest-view-btn]'
    };

    this.shareButton = document.querySelectorAll('[share-list-toggle]');
    this.editAccountBtn = document.querySelectorAll('[edit-account-btn]');
    this.guestViewBtn = document.querySelectorAll('[guest-view-btn]');

    this.init();
  }

  init() {
    this.setupEventListeners(this.editAccountBtn, () => this.handleAccDetailsHtml());
    this.setupEventListeners(this.shareButton, () => this.handleShareHtml());
    this.setupEventListeners(this.guestViewBtn, this.openGuestMode.bind(this));

    if (window.location.href.includes('?type=share-list')) {
      this.handleShareHtml();
    }
  }

  setupEventListeners(elements, handler) {
    if (elements.length > 0) {
      elements.forEach(btn => {
        btn?.addEventListener('click', handler);
      });
    }
  }

  async loadAndDisplayContent(selector, elementSelector, flyoutFooterSelector) {
    const scriptHtml = document.querySelector(selector)?.innerHTML;
    const flyoutModal = document?.querySelector(this.selectors.flyoutModal);
    const flyoutBody = flyoutModal?.querySelector(this.selectors.flyoutBody);
    const flyoutFooter = flyoutModal?.querySelector(this.selectors.flyoutFooter);

    if (!scriptHtml || !flyoutModal || !flyoutBody || !flyoutFooter) {
      console.error('One or more required elements are missing.');
      return;
    }

    flyoutFooter.innerHTML = '';
    flyoutBody.innerHTML = '';

    const parser = new DOMParser();
    const doc = parser.parseFromString(scriptHtml, 'text/html');
    const element = doc.querySelector(elementSelector);
    const footerContent = doc.querySelector(flyoutFooterSelector);

    if (footerContent) {
      flyoutFooter.appendChild(footerContent);
    }

    if (element) {
      flyoutBody.appendChild(element);
    }

    flyoutModal.openFlyout();
  }


  handleShareHtml() {
    this.loadAndDisplayContent(
      this.selectors.shareChecklistHtml,
      'list-share-element',
      '.list-share__btns'
    );
    this.updateUrl();
    const flyoutModalHeading = document?.querySelector(this.selectors.flyoutModalHeading);
    if (flyoutModalHeading) { flyoutModalHeading.textContent = 'שיתוף רשימת הלידה עם משפחה וחברים'; }
  }

  handleAccDetailsHtml() {
    this.loadAndDisplayContent(
      this.selectors.customerEditDetailHtml,
      'customer-details-edit',
      '.customer-dt__footer'
    );
  }

  updateUrl() {
    const newUrl = window.location.href.replace('?type=share-list', '');
    window.history.replaceState({}, document.title, newUrl);
  }

  openGuestMode(event) {
    const dataHref = event.target.dataset.href;
    if (dataHref) {
      window.open(dataHref, '_blank');
    }
  }
}

customElements.define('customer-account-banner', CustomerAccountBanner);




class ProductPurchaseGift extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      btnSubmit: '[btn-submit-info]',
      btnCancel: '[btn-cancel]',
      inputs: '[customer-pr-input]',
      successBox: '.success-box',
      flyoutModal: 'flyout-modal-js',
    };
  }

  connectedCallback() {
    this.btnSubmit = this.querySelector(this.selectors.btnSubmit);
    this.btnCancel = this.querySelector(this.selectors.btnCancel);
    this.inputs = this.querySelectorAll(this.selectors.inputs);
    this.successBox = this.querySelector(this.selectors.successBox);
    this.flyoutModal = this.closest(this.selectors.flyoutModal);

    this.init();
  }

  init() {
    this.checkGlInputs();
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.inputs?.forEach(input => { input?.addEventListener('input', () => { this.checkInputs(input); }); input?.addEventListener('change', () => { this.checkInputs(input); }); input.addEventListener('onautocomplete', () => this.checkInputs(input)); });
    this.btnSubmit?.addEventListener('click', () => { this.handleSubmit(); });
    this.btnCancel?.addEventListener('click', () => { this.flyoutModal.closeFlyout(); });
  }

  checkInputs() {
    let allFilled = true;
    this.inputs.forEach(inp => {
      if (inp.required && !inp.value.trim()) {
        allFilled = false;
      }
    });
    this.btnSubmit.disabled = !allFilled;
  }


  checkGlInputs() {
    let allFilled = true;
    this.inputs.forEach(input => {
      if (input.required && !input.value) {
        allFilled = false;
      }
    });

    if (allFilled) {
      this.btnSubmit.disabled = false;
    } else {
      this.btnSubmit.disabled = true;
    }
  }

  handleSubmit() {
    this.formData = {};
    this.inputs?.forEach((input) => {
      const name = input.dataset.name || input.name || '';
      const value = input.value || '';  // ✅ Fixed: use input.value (not dataset.value)
      if (name && value) this.formData[name] = value;
    });

    // ✅ Fixed: Get customer ID from URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const checklistParam = urlParams.get('type'); // e.g., "checklist-9483271143712"
    const customerId = checklistParam ? checklistParam.replace('checklist-', '') : '';
    
    console.log('🔍 Mark as purchased - customer ID:', customerId);
    console.log('🔍 this.jsonData:', this.jsonData);
    console.log('🔍 this.formData:', this.formData);
    
    if (!customerId) {
      console.error('❌ Customer ID not found in URL');
      alert('שגיאה: לא נמצא מזהה לקוח. אנא נסה שוב.');
      return;
    }
    
    const productJson = {
      purchased: true,
      customer_id: customerId,  // ✅ Now has value!
      purchased_date: new Date().toISOString(),  // ✅ Add timestamp
      ...this.jsonData,
      ...this.formData
    };

    console.log('📤 Sending to api/purchased/checklist:', productJson);

    // Analytics — Event 23: gift_note_submitted / gift_purchase_by_giver (fired from client side)
    try {
      if (window.ChecklistAnalytics) {
        window.ChecklistAnalytics.track('gift_note_submitted', {
          product_id: this.jsonData?.product_id || null,
          variant_id: this.jsonData?.variant_id || null,
          product_title: this.jsonData?.product_title || null,
          category_id: this.jsonData?.category_id || null,
          collection_id: this.jsonData?.collection_id || null,
          checklist_owner_id: customerId,
          has_gift_note: !!(this.formData && (this.formData.gift_note || this.formData.giftNote)),
          purchase_location: this.formData?.purchase_location || this.formData?.purchaseLocation || null,
        });
      }
    } catch (e) {}

    this.btnSubmit.classList.add('btn--loading');
    this.btnSubmit.disabled = true;
    this.sendCustomerData(productJson);
  }

  async sendCustomerData(data) {
    console.log('📤 Sending purchased gift data:', data);

    try {
      const response = await fetch('https://app.motsesim.co.il/api/purchased/checklist?shop=motsesim.myshopify.com', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify(data),
      });

      console.log('📥 Response status:', response.status);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('✅ Backend response:', result);

      if (result.status === 200) {
        console.log('✅ Gift marked as purchased successfully!');
        if (this.successBox) { 
          this.successBox.classList.remove('hidden'); 
          setTimeout(() => { 
            this.successBox.classList.add('hidden'); 
          }, 5000); 
        }
        this.btnSubmit.disabled = false;
        this.btnSubmit.classList.remove('btn--loading');
        setTimeout(() => {
          this.flyoutModal.closeFlyout();
          console.log('🔄 Reloading page to show updated gift status...');
          window.location.reload();
        }, 2000);
      } else {
        console.error('❌ Backend returned non-200 status:', result);
        this.btnSubmit.disabled = false;
        this.btnSubmit.classList.remove('btn--loading');
        alert('שגיאה בשמירת הנתונים. אנא נסה שוב.');
      }
    } catch (error) {
      console.error('❌ Error sending purchased gift data:', error);
      this.btnSubmit.disabled = false;
      this.btnSubmit.classList.remove('btn--loading');
      alert('שגיאה בשמירת הנתונים. אנא נסה שוב.');
    }
  }
}
customElements.define('product-purchased-gift', ProductPurchaseGift);


// ✅ Apply member pricing for shared checklist guests in cart drawer
function applySharedChecklistPricingToCart() {
  const sharedSession = localStorage.getItem('shared_checklist_session');
  
  if (!sharedSession) {
    console.log('No shared session found');
    return;
  }
  
  try {
    const sharedData = JSON.parse(sharedSession);
    if (!sharedData.active) {
      console.log('Shared session not active');
      return;
    }
    
    console.log('✅ Shared checklist guest detected - will apply member pricing to cart');
    
    // Set a flag that other scripts can check
    window.isSharedChecklistGuest = true;
    window.sharedChecklistData = sharedData;
    
    console.log('📢 Set window.isSharedChecklistGuest = true for cart pricing');

    // ✅ Apply purple pricing to cart drawer items
    applyPurplePricesToCartDrawer();

    // ✅ Switch from regular cart to member cart (purple prices)
    setTimeout(() => {
      const normalCart = document.querySelector('.mm_cart-normal');
      const checkCart  = document.querySelector('.mm_cart-check');

      console.log('🔄 Switching cart display:', {
        normalCartFound: !!normalCart,
        checkCartFound: !!checkCart
      });

      if (normalCart && checkCart) {
        normalCart.style.display = 'none';
        checkCart.style.display  = 'block';
        console.log('✅ Switched to member cart (purple prices)');
      } else {
        console.warn('⚠️ Cart elements not found yet, retrying...');
        // Retry after cart is rendered
        setTimeout(() => {
          const n = document.querySelector('.mm_cart-normal');
          const c = document.querySelector('.mm_cart-check');
          if (n && c) {
            n.style.display = 'none';
            c.style.display = 'block';
            console.log('✅ Switched to member cart (retry successful)');
      }
        }, 2000);
      }
    }, 1000);  // Reduced from 3000ms
    
  } catch (e) {
    console.warn('Could not parse shared session:', e);
  }
}

// ✅ Apply purple prices to cart drawer for shared guests
function applyPurplePricesToCartDrawer() {
  console.log('💜 Applying purple prices to cart drawer...');
  
  // Find all cart items and force show sale prices
  const cartItems = document.querySelectorAll('.cart-item, .cart__drawerItemWrapper');
  console.log(`Found ${cartItems.length} cart items to style`);
  
  cartItems.forEach((item, index) => {
    // Add price--on-sale class to trigger purple styling
    const priceElements = item.querySelectorAll('.price, .cart-item__prices .price');
    priceElements.forEach(priceEl => {
      priceEl.classList.add('price--on-sale');
    });
    
    // Force show member price text if it exists
    const memberPriceText = item.querySelectorAll('.mm_cp-member');
    memberPriceText.forEach(el => {
      el.style.display = 'block';
    });
    
    console.log(`  ${index + 1}. Styled cart item`);
  });
  
  console.log('✅ Purple prices applied to cart drawer');
}

// ✅ Listen for cart updates and re-apply styling
document.addEventListener('cart:updated', () => {
  console.log('🔄 Cart updated - re-applying purple prices...');
  setTimeout(() => {
    if (window.isSharedChecklistGuest) {
      applyPurplePricesToCartDrawer();
    }
  }, 300);
});

// Also listen for cart drawer opening
document.addEventListener('cart-drawer:open', () => {
  console.log('🛒 Cart drawer opened - applying purple prices...');
  setTimeout(() => {
    if (window.isSharedChecklistGuest) {
      applyPurplePricesToCartDrawer();
    }
  }, 100);
});

// Run immediately
applySharedChecklistPricingToCart();

// Also apply to cart on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      if (window.isSharedChecklistGuest) {
        applyPurplePricesToCartDrawer();
      }
    }, 1000);
  });
} else {
  setTimeout(() => {
    if (window.isSharedChecklistGuest) {
      applyPurplePricesToCartDrawer();
    }
  }, 1000);
}